<template>
  <md-card>
    <md-card-header class="md-card-header-text md-card-header-primary">
      <div class="card-text" style="display: block; background: grey;">
        <h4 class="title">{{ $t("List of RPAS") }}</h4>
      </div>
    </md-card-header>
    <md-card-content>
      <md-table
        table-header-color="primary"
        class="paginated-table table-striped table-hover"
      >
        <md-table-head>ID</md-table-head>
        <md-table-head>{{ $t("Manufacturer") }}</md-table-head>
        <md-table-head>{{ $t("Model") }}</md-table-head>
        <md-table-head>{{ $t("RPAS Nickname") }}</md-table-head>
        <md-table-head>{{ $t("Registration No.") }}</md-table-head>
        <md-table-head>{{ $t("Colour") }}</md-table-head>
        <md-table-head class="check">{{ $t("View") }}</md-table-head>
        <md-table-head class="check">{{ $t("Edit") }}</md-table-head>
        <md-table-toolbar>
          <md-field>
            <label for="pages">{{ $t("Per page") }}</label>
            <md-select v-model="pagination.perPage" name="pages">
              <md-option
                v-for="(item, position) in pagination.perPageOptions"
                :key="position"
                :label="item"
                :value="item"
                >{{ item }}</md-option
              >
            </md-select>
          </md-field>

          <md-field>
            <md-button
              class="md-raised md-primary mt-4"
              @click="showEditor(null)"
            >
              {{ $t("Add") }}
            </md-button>
          </md-field>
        </md-table-toolbar>
        <md-table-row v-for="(item, position) in drones" :key="position">
          <md-table-cell v-if="item.model.length > 0" md-label="ID">
            {{ position + 1 }}
          </md-table-cell>
          <md-table-cell
            v-if="item.model.length > 0"
            :md-label="$t('Manufacturer')"
          >
            {{ item.manufacturer }}
          </md-table-cell>
          <md-table-cell v-if="item.model.length > 0" :md-label="$t('Model')">
            {{ item.model }}
          </md-table-cell>
          <md-table-cell
            v-if="item.model.length > 0"
            :md-label="$t('RPAS Nickname')"
          >
            {{ item.nickname }}
          </md-table-cell>
          <md-table-cell
            v-if="item.model.length > 0"
            :md-label="$t('Registration Number')"
          >
            <label style="line-height: 52px">
              {{ item.registrationnumber }}
            </label>
            <md-button
              class="md-just-icon md-simple md-primary"
              v-if="item.certificateFile && item.model.length > 0"
            >
              <a target="blank" :href="CERTIFICATE_URL + item.certificateFile">
                <md-icon>visibility</md-icon>
              </a>
            </md-button>
          </md-table-cell>
          <md-table-cell v-if="item.model.length > 0" :md-label="$t('Colour')">
            {{ item.color }}
          </md-table-cell>
          <md-table-cell
            v-if="item.model.length > 0"
            :md-label="$t('View')"
            class="check"
          >
            <md-button
              class="md-just-icon md-simple md-primary"
              @click="showPageDetail(item, position)"
            >
              <md-icon>list_alt</md-icon>
            </md-button>
          </md-table-cell>
          <md-table-cell
            v-if="item.model.length > 0"
            :md-label="$t('Edit')"
            class="check"
          >
            <md-button
              class="md-just-icon md-simple md-primary"
              @click="showEditor(item, position)"
            >
              <md-icon>edit</md-icon>
            </md-button>
          </md-table-cell>
        </md-table-row>
      </md-table>
    </md-card-content>
    <md-card-actions md-alignment="space-between">
      <p class="card-category">
        {{
          `${$t("Showing")} ${from + 1} ${$t("to")} ${to} ${$t("of")} ${total} ${$t("entries")}`
        }}
      </p>
      <pagination
        class="pagination-no-border"
        v-model="pagination.currentPage"
        :per-page="pagination.perPage"
        :total="total"
      />
    </md-card-actions>
  </md-card>
</template>

<script>
import { Pagination } from "@/components";
import { CERTIFICATE_URL } from "@/helpers";

export default {
  components: { Pagination },
  props: {
    drones: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      pagination: {
        perPage: 10,
        currentPage: 1,
        perPageOptions: [10, 25, 50, 100],
        total: 0
      },
      searchedData: [],
      responsive: false,
      CERTIFICATE_URL
    };
  },
  computed: {
    queriedData() {
      return this.drones.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length - 1
        : this.drones.length - 1;
    }
  },
  methods: {
    showEditor(item, position) {
      this.$emit("showEditor", item, position);
    },
    showPageDetail(item, position) {
      this.$emit("showPageDetail", item, position);
    }
  }
};
</script>
